import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DisplayLinkStats } from '../email-stats/email-stats';
import { EmailEventService, SenderType } from '@vendasta/email';
import { map, switchMap } from 'rxjs/operators';
import { formatPercentage } from '../email-stats/utils';
import { AttributeInterface } from '@vendasta/email';
import { SENDER_ID_TOKEN } from '../dependencies';

@Injectable({
  providedIn: 'root',
})
export class LinkActivityService {
  constructor(
    @Inject(SENDER_ID_TOKEN) readonly senderId$: Observable<string>,
    private emailEventService: EmailEventService,
  ) {}

  loadLinkActivity(att: AttributeInterface): Observable<DisplayLinkStats[]> {
    return this.senderId$.pipe(
      switchMap((senderId) => {
        const senderType = senderId.startsWith('AG') ? SenderType.SENDER_TYPE_BUSINESS : SenderType.SENDER_TYPE_PARTNER;
        return this.emailEventService.getAttributeEventLinkStats(
          {
            type: senderType,
            id: senderId,
          },
          {
            key: att.key,
            value: att.value,
          },
        );
      }),
      map((resp) => {
        if (resp.data) {
          return resp.data.map((stat) => {
            return {
              url: stat.url,
              displayUrl: stat.url?.replace('{{', '').replace('}}', '').trim(),
              totalClicks: stat.totalClicks,
              uniqueClicks: stat.uniqueClicks,
              displayClickRate: stat.clickRate ? formatPercentage(stat.clickRate) : '0%',
            } as DisplayLinkStats;
          });
        } else {
          return [
            {
              url: '',
              displayUrl: '',
              totalClicks: 0,
              uniqueClicks: 0,
              displayClickRate: '0%',
            } as DisplayLinkStats,
          ];
        }
      }),
    );
  }
}
